import { useState } from 'react';
import EmbedResult from '../components/EmbedResult/EmbedResult';
import LinkInput from '../components/LinkInput/LinkInput';
import MainLayout from '../layouts/MainLayout/MainLayout';

function HomePage() {

  const [embed, setEmbed] = useState<string | null>(null);

  const onEmbedResult = (embed: string | null) => {
    if (embed !== null) {
      navigator.clipboard.writeText(embed);
    }
    setEmbed(embed);
  };

  const inputDisplay = 
    <LinkInput onEmbedResults={onEmbedResult} />;

  const embedDisplay = embed !== null
    ? <EmbedResult embed={embed} /> : null;

  return (
    <MainLayout title="Dan's Youtube Embedder">
      { inputDisplay }
      { embedDisplay }
    </MainLayout>
  );
}

export default HomePage;